export default "__VITE_ASSET__d63e6406__"